module.exports = __webpack_public_path__ + "d752899a4aa4f0cf60b34027662e4ebe.svg";